import { EventEmitter } from '@angular/core';
import { Pagination } from '@cervotech/types/api';
import { PageChangedEvent } from '../../../components/pagination/interfaces';
import { BehaviorSubject } from './behavior-subject';

export interface SelectorItem<T = any> {
  id: any;
  title: string;
  data?: T;
}

export class ItemsSelector {
  // Do not use for preselection
  selectedItemsMap: Map<SelectorItem['id'], SelectorItem> = new Map();

  items = new BehaviorSubject<SelectorItem[]>([]);
  loading = new BehaviorSubject<boolean>(false);
  pagination = new BehaviorSubject<Pagination | null>();
  currentPage = new BehaviorSubject<PageChangedEvent>({ page: 1 });
  selected = new BehaviorSubject<SelectorItem[] | SelectorItem | null>();

  // Capable of triggering data loading for the first time
  search = new BehaviorSubject<string | undefined>('');

  newItem = new EventEmitter<string>();
  refresh = new EventEmitter<string>();

  constructor(
    public multipleSelection = true,
    public disableSelector = false, // Use to prevent the selector from opening
    public showAddNewButton = true
  ) {}

  preSelect(value: SelectorItem[] | SelectorItem | null) {
    if (!this.multipleSelection) {
      this.selectedItemsMap.clear();
    }

    this.selected.setValue(value);

    if (Array.isArray(value)) {
      value.forEach((item) => {
        this.selectedItemsMap.set(item.id, item);
      });
      return;
    }

    if (value) {
      this.selectedItemsMap.set(value.id, value);
    }
    this.refresh.emit();
  }

  reset() {
    this.selected.next(null);
    this.selectedItemsMap.clear();
    this.currentPage.setValue({ page: 1 });
    this.search.setValue('');
    this.refresh.emit();
  }
}
